<script>
import { getCurrentInstance, provide, computed, unref, watch } from 'vue'
import { USER_INJECTION_KEY } from '../../../tokens/index'
import { useStyleCssVars } from '../hook/use-style-css-vars'
export default {
  props: {
    themeColor: Object,
    colorHook: Function,
    scanOptions: Object,
  },
  setup(props, { slots }) {
    const { proxy } = getCurrentInstance()
    // const user = {
    //   currentToken: null,
    //   organization: null,
    //   system: null,
    //   solution: { theme: 'union' },
    //   latestVasion: null,
    //   CurrentTicket: null,
    //   systemOpenInfo: null,
    //   version:null
    // }
    // const mutations = {
    //   setUser(state, user) {
    //     state.currentToken = user
    //   },
    // }
    const user = computed(() => proxy?.$store?.state?.user)
    const menuStore = computed(() => proxy.$store?.state?.menuStore)

    provide(USER_INJECTION_KEY, {
      userState: unref(user),
      menuState: unref(menuStore),
      commit: (name, ...arg) => {
        // if(mutations[name]){
        //   mutations[name](user, ...arg)
        // }else {
        //   console.error(`useUser中未定义${name}方法`)
        // }
        proxy.$store.commit(name, ...arg)
      },
    })

    provide('scanOptionInjection', props.scanOptions)

    const { setCssVar, primaryStyleVars } = useStyleCssVars(props.themeColor, props.colorHook, user)
    watch(
      () => props.themeColor,
      () => {
        Object.keys(props.themeColor ?? {}).forEach((key) => {
          primaryStyleVars.value[key] = props.themeColor[key]
        })
        setCssVar()
      },
      { immediate: true }
    )

    return () => slots.default?.()
  },
}
</script>
<style lang="scss">
@import '../../../styles/common/common.scss';
</style>
